/** Status / tier / identity chips shared by the songs table and the song editor (CMS-03). */
import type { MatchStatus, SongStatus, Tier } from '@akpl/shared';

import { useT } from '../../i18n';
import { Badge, type BadgeProps } from '../ui/panel';

const STATUS_TONE: Record<SongStatus, NonNullable<BadgeProps['tone']>> = {
  draft: 'neutral',
  ready: 'cyan',
  published: 'ok',
  archived: 'danger',
};

export function StatusBadge({ status }: { status: SongStatus }) {
  const { t } = useT();
  return (
    <Badge tone={STATUS_TONE[status]}>{t(`cms:status.${status}` as 'cms:status.draft')}</Badge>
  );
}

const TIER_TONE: Record<Tier, NonNullable<BadgeProps['tone']>> = {
  standard: 'neutral',
  recent: 'cyan',
  vip: 'pink',
};

export function TierBadge({ tier }: { tier: Tier }) {
  const { t } = useT();
  return <Badge tone={TIER_TONE[tier]}>{t(`common:tier.${tier}` as 'common:tier.standard')}</Badge>;
}

const MATCH_TONE: Record<MatchStatus, NonNullable<BadgeProps['tone']>> = {
  matched: 'ok',
  review: 'warn',
  unmatched: 'danger',
};

/** `matched` / `revisión` / `sin match`, or a neutral "no ids" when catalog-identify never ran. */
export function MatchBadge({ status }: { status: MatchStatus | null }) {
  const { t } = useT();
  if (!status) return <Badge tone="neutral">{t('cms:songs.match.none')}</Badge>;
  return (
    <Badge tone={MATCH_TONE[status]}>
      {t(`cms:songs.match.${status}` as 'cms:songs.match.matched')}
    </Badge>
  );
}
